module.exports = __webpack_public_path__ + "static/media/brush_8.72ce9bca.png";